/**
 * Рекурсивно добавляет ссылку на родителя каждому объекту
 * @param {Array|Object} node - текущий узел
 * @param {Object|null} parent - родительский объект
 */
export function attachParents(node, parent = null) {
  if (Array.isArray(node)) {
    node.forEach(item => attachParents(item, parent))
  } else if (node && typeof node === 'object') {
    node._parent = parent
    if (node.sg) attachParents(node.sg, node)
    if (node.tg) attachParents(node.tg, node)
    if (node.fg) attachParents(node.fg, node)
    if (node.ffg) attachParents(node.ffg, node)
  }
}

/**
 * Поднимается по цепочке родителей и вызывает колбек для каждого
 * @param {Object} node - узел, с которого начинаем
 * @param {Function} callback - функция, которая вызывается для каждого родителя
 */
export function walkParents(node, callback) {
  let current = node._parent
  while (current) {
    callback(current)
    current = current._parent
  }
}

/**
 * Сравнивает размер данных отчета с лимитом памяти, который этот отчет может занять в localStorage 
 * @param data - данные отчета
 * @param limitMB - лимит для текущего отчета
 * @returns {boolean} - можно ли сохранить в localStorage
 */
export function canFitInLocalStorage(data, limitMB = 0.5) {
  try {
    const jsonData = JSON.stringify(data);
    const jsonDataSize = jsonData.length * 2; // data size (bytes)
    return jsonDataSize < limitMB * 1024 * 1024 // limit in MB
  } catch (e) {
    return false;
  }
}